import React, { useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { AuthContext } from '../context/AuthContext';
import '../styles/Login.css';

function ForgotPassword() {
  const { resetPassword } = useContext(AuthContext);
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [sent, setSent] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    try {
      await resetPassword(email);
      setSent(true);
    } catch (err) {
      switch (err.code) {
        case 'auth/user-not-found':
          setError('Kein Konto mit dieser E-Mail gefunden');
          break;
        case 'auth/invalid-email':
          setError('Ungültige E-Mail-Adresse');
          break;
        case 'auth/too-many-requests':
          setError('Zu viele Anfragen. Bitte versuch es später erneut');
          break;
        default:
          setError('Die E-Mail konnte nicht gesendet werden');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Passwort zurücksetzen | DynaStoxx</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className="login-container">
        <div className="login-card">
          <div className="login-header">
            <h1>Passwort zurücksetzen</h1>
            <p className="text-muted">Wir schicken dir einen Link, mit dem du ein neues Passwort setzen kannst.</p>
          </div>

          {sent ? (
            <div className="login-form">
              <div className="success-message" role="status">
                <i className="fas fa-check-circle" aria-hidden="true"></i>
                Falls ein Konto mit dieser E-Mail existiert, ist der Link unterwegs. Bitte prüfe auch deinen Spam-Ordner.
              </div>
              <Link to="/login" className="login-button">Zurück zum Login</Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="login-form">
              {error && (
                <div className="error-message" role="alert">
                  <i className="fas fa-exclamation-circle" aria-hidden="true"></i>
                  {error}
                </div>
              )}
              <div className="form-group">
                <label htmlFor="reset-email">E-Mail-Adresse</label>
                <div className="input-group">
                  <span className="input-group-text">
                    <i className="fas fa-envelope" aria-hidden="true"></i>
                  </span>
                  <input
                    id="reset-email"
                    type="email"
                    className="form-control"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Gib deine E-Mail ein"
                    autoComplete="email"
                    required
                  />
                </div>
              </div>
              <button type="submit" className="login-button" disabled={isLoading}>
                {isLoading ? <i className="fas fa-spinner fa-spin" aria-hidden="true"></i> : 'Link senden'}
              </button>
              <div className="register-prompt">
                <Link to="/login">Zurück zum Login</Link>
              </div>
            </form>
          )}
        </div>
      </div>
    </>
  );
}

export default ForgotPassword;
